// Funciones genericas para transformado de datos de las columnas. 
// La columna toma como valor a filtrar, mostrar y ordenar el valor devuelto por esta funcion

import moment from "moment";

export const dateAccesor = (accesorKey) => {
  return (row) => (
    row[accesorKey]
      ? moment(row[accesorKey]).format("DD/MM/YYYY")
      : "N/A"
  )
};

export const dateTimeAccesor = (accesorKey) => {
  return (row) => (
    row[accesorKey]
      ? moment(row[accesorKey]).format("DD/MM/YYYY HH:mm:ss")
      : "N/A"
  )
};